import type { FunctionComponent } from 'react';

import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

import styles from './playlistSkeleton.module.scss';

export const PlaylistSkeleton: FunctionComponent = () => (
  <div className={styles.slider}>
    {[...Array(5)].map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton className={styles.card} key={`product-card-${index}`} />
    ))}
  </div>
);
